<table class="custom-table">
  <thead>
    <tr>
      @for (col of columns; track col.key) {
        <th>
          <div class="table-head-left">
            {{ col.label }}
            @if (col.allowSort) {
              @if (sortColumn === col.key) {
                <img
                  class="active"
                  (click)="setSort(col.key)"
                  (keyup.enter)="setSort(col.key)"
                  (keyup.space)="setSort(col.key)"
                  tabindex="0"
                  [src]="'assets/filter-' + (sortDirection === SortDirection.ASC ? 'asc' : 'desc') + '.svg'"
                  alt="Sortierung"
                />
              } @else {
                <img
                  (click)="setSort(col.key)"
                  (keyup.enter)="setSort(col.key)"
                  (keyup.space)="setSort(col.key)"
                  tabindex="0"
                  src="assets/filter.svg"
                  alt="Sortierung"
                />
              }
            }
          </div>
        </th>
      }
      <th class="align-center">
        <div class="table-head-center">Aktionen</div>
      </th>
    </tr>
  </thead>
  <tbody>
    @for (user of users; track user.id) {
      <tr>
        <td class="responsive-cell">{{ user.firstName || '-' }}</td>
        <td class="responsive-cell">{{ user.lastName || '-' }}</td>
        <td class="responsive-cell">{{ user.email }}</td>
        <td class="responsive-cell">{{ getCustomerName(user.customerId) }}</td>
        <td class="responsive-cell align-center actions-cell">
          <button class="link-like" (click)="onEditClick(user, $event)">Bearbeiten</button>
        </td>
      </tr>
    }
    @if (!users || users.length === 0) {
      <tr>
        <td colspan="5" class="align-center">{{ emptyMessage }}</td>
      </tr>
    }
  </tbody>
  <tfoot>
    <tr>
      <td colspan="5">
        <div class="pagination-controls">
          <p-paginator
            (onPageChange)="onPageChange($event)"
            [first]="first"
            [rowsPerPageOptions]="itemsPerPageOptions"
            [rows]="itemsPerPageShown"
            [totalRecords]="totalRecords"
          />
        </div>
      </td>
    </tr>
  </tfoot>
</table>
